module.exports = __webpack_public_path__ + "static/img/patho-tympanic-lesions-67OGZhE_.7639f43f.png";